import { render } from "./GoToTop.vue?vue&type=template&id=482bf2b5"
import script from "./GoToTop.vue?vue&type=script&lang=js"
export * from "./GoToTop.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benme\\Documents\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__